import rmskincareAPI from '../utils/rmskincareAPI'

const resourceApi = {
  /* ─── Resource Groups ─────────────────────────────────────── */

  getResourceGroups: async (locationId) => {
    const result = await rmskincareAPI.get(
      `/management/resource-group?locationId=${locationId}`
    )
    return result.data.data
  },

  createResourceGroup: async (body) => {
    const result = await rmskincareAPI.post(`/management/resource-group`, body)
    return result.data.data
  },

  updateResourceGroup: async (groupId, body) => {
    const result = await rmskincareAPI.put(
      `/management/resource-group/${groupId}`,
      body
    )
    return result.data.data
  },

  deleteResourceGroup: async (groupId) => {
    const result = await rmskincareAPI.delete(
      `/management/resource-group/${groupId}`
    )
    return result.data.data
  },

  reorderResourceGroups: async (locationId, orderedIds) => {
    const result = await rmskincareAPI.put(
      `/management/resource-group/reorder`,
      { locationId, orderedIds }
    )
    return result.data.data
  },

  /* ─── Resources ───────────────────────────────────────────── */

  createResource: async (body) => {
    const result = await rmskincareAPI.post(`/management/resource`, body)
    return result.data.data
  },

  updateResource: async (resourceId, body) => {
    const result = await rmskincareAPI.put(
      `/management/resource/${resourceId}`,
      body
    )
    return result.data.data
  },

  deleteResource: async (resourceId) => {
    const result = await rmskincareAPI.delete(
      `/management/resource/${resourceId}`
    )
    return result.data.data
  },

  reorderResources: async (groupId, orderedIds) => {
    const result = await rmskincareAPI.put(`/management/resource/reorder`, {
      groupId,
      orderedIds,
    })
    return result.data.data
  },

  /* ─── Resource Schedule ───────────────────────────────────── */

  getResourceSchedule: async (resourceId, weekStart) => {
    const params = weekStart ? `?weekStart=${weekStart}` : ''
    const result = await rmskincareAPI.get(
      `/management/resource/${resourceId}/schedule${params}`
    )
    return result.data.data
  },

  saveResourceSchedule: async (resourceId, body) => {
    const result = await rmskincareAPI.post(
      `/management/resource/${resourceId}/schedule`,
      body
    )
    return result.data.data
  },

  getRepeatingSchedule: async (resourceId, dayOfWeek) => {
    const result = await rmskincareAPI.get(
      `/management/resource/${resourceId}/repeating-schedule?dayOfWeek=${dayOfWeek}`
    )
    return result.data.data
  },

  saveRepeatingSchedule: async (resourceId, body) => {
    const result = await rmskincareAPI.post(
      `/management/resource/${resourceId}/repeating-schedule`,
      body
    )
    return result.data.data
  },

  saveDayOverride: async (resourceId, body) => {
    const result = await rmskincareAPI.post(
      `/management/resource/${resourceId}/day-override`,
      body
    )
    return result.data.data
  },

  /* ─── Resource Services (read-only) ──────────────────────── */

  getResourceServices: async (resourceId) => {
    const result = await rmskincareAPI.get(
      `/management/resource/${resourceId}/services`
    )
    return result.data.data
  },
}

export default resourceApi
